import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
})
export class UnsubscribeComponent implements OnInit {
  queryParams: any;
  isSub: boolean = true
  isLoading: boolean = false


  constructor(
    private http: HttpClient,
    private router: ActivatedRoute,

  ) { }

  ngOnInit(): void {
    this.router.queryParams.subscribe((params) => {
      this.queryParams = params;
    });
  }

  unsubscribe(){
    this.isLoading = true
    this.http.post
    this.isSub = false
    this.isLoading = false
  }
}
